import { getConfigObject, useMutationWithLoading } from "../../utils/utils";
import { Role, RolesAndPrivilegesControllerApi } from "../../services";

/**
 * @author rajkumar rathod
 */
interface Params {
  role: Role;
  xTENANTID?: string;
}
export const useAddRole = () =>
  useMutationWithLoading(async (params: Params) =>
    new RolesAndPrivilegesControllerApi(getConfigObject()).addNewRole(
      params?.role,
      params?.xTENANTID
    )
  );
